import React from 'react'
import { Tooltip, ListItemButton, ListItemText } from '@mui/material'
import { useLang } from '~/hooks/useLang'
import useUserState from '~/features/User/stores/UserState'
import { History } from 'history' // Ajuste o import se necessário para o tipo correto

interface AuditMenuItemProps {
  readonly permission: readonly string[]
  readonly route: string
  readonly label: string
  readonly tooltip: string
  readonly handleMenuClick: (menu: string) => void
  readonly history: History
}

export default function AuditMenuItem({
  permission,
  route,
  label,
  tooltip,
  handleMenuClick,
  history,
}: AuditMenuItemProps) {
  const { translate } = useLang()
  const { verifyPermission } = useUserState()

  return verifyPermission(permission) ? (
    <Tooltip title={translate(tooltip)} placement="right">
      <ListItemButton
        onClick={() => {
          handleMenuClick('audit')
          history.push(route)
        }}
      >
        <ListItemText primary={translate(label)} />
      </ListItemButton>
    </Tooltip>
  ) : null
}